import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FaXmark } from 'react-icons/fa6';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgba(11, 42, 61, 0.82);
  backdrop-filter: blur(4px);
  animation: overlayFade 0.25s ease;

  @keyframes overlayFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const Frame = styled.div`
  position: relative;
  width: 100%;
  max-width: 900px;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-strong);
  animation: frameRise 0.3s ease;

  @keyframes frameRise {
    from { opacity: 0; transform: translateY(16px) scale(0.98); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }

  /* Proporção 16:9 via padding-top (compatível com qualquer navegador,
     diferente de "aspect-ratio"). */
  &::before {
    content: '';
    display: block;
    padding-top: 56.25%;
  }

  iframe {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -3rem;
  right: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-accent);
  color: var(--color-white);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: var(--color-accent-hover);
    transform: rotate(90deg);
  }

  @media screen and (max-width: 768px) {
    top: -3rem;
    right: 0;
  }
`;

const VideoModal = ({ isOpen, onClose, videoUrl, title = 'Vídeo demonstrativo do SofChef' }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Overlay role="dialog" aria-modal="true" aria-label={title} onClick={onClose}>
      <Frame onClick={(event) => event.stopPropagation()}>
        <CloseButton onClick={onClose} aria-label="Fechar vídeo">
          <FaXmark size={18} />
        </CloseButton>
        <iframe
          src={videoUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </Frame>
    </Overlay>
  );
};

export default VideoModal;
